import { lazy } from "react";

export const LazyAssessmentListPage = lazy(async () => ({
    default: (await import("./AssessmentListPage")).AssessmentListPage
}));

export const LazyAssessmentPage = lazy(async () => ({
    default: (await import("./AssessmentPage")).AssessmentPage
}));

export const LazyAssessmentSidebarNav = lazy(async () => ({
    default: (await import("./AssessmentSidebarNav")).AssessmentSidebarNav
}));
